import React from "react";
import AppLayout from "./components/common/AppLayout";
import Header from "./components/common/Header";
import Sidebar from "./components/common/Sidebar";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import { ProSidebarProvider } from "react-pro-sidebar";
import RtuManagePage from "./pages/RtuManagePage";
import RtuRequestPage from "./pages/RtuRequestPage";
import RtuReceiveLogPage from "./pages/RtuReceiveLogPage";
import RtuSendLogPage from "./pages/RtuSendLogPage";
import RemsSendLogPage from "./pages/RemsSendLogPage";
import ExternalApiSendLogPage from "./pages/ExternalApiSendLogPage";
import RtuSettingRoutes from "pages/routes/RtuSettingRoutes";
import RemsInterlockAddRoutes from "pages/routes/RemsInterlockAddRoutes";
import ExternalApiRoutes from "pages/routes/ExternalApiRoutes";
import AuthorityCheckRoute from "utils/AuthorityCheckRoute";
import { MenuAuthorityChoice, UserAuthorityChoice } from "utils/common";
import UsersPage from "pages/UsersPage";
import DeviceModelSettingsPage from "pages/DeviceModelSettingsPage";
import PollingInverterModelsPage from "pages/PollingInverterModelsPage";
import SolaronPolicyPage from "./pages/SolaronPolicyPage";

export default function Main() {
  return (
    <ProSidebarProvider>
      <AppLayout header={<Header />} sidebar={<Sidebar />}>
        <Routes>
          <Route path="*" element={<HomePage />} />
          <Route path="/rtu-manage/" element={<RtuManagePage />} />
          <Route path="/rtu-setting/*" element={<RtuSettingRoutes />} />
          <Route path="/rtu-request/" element={<RtuRequestPage />} />
          <Route path="/rtu-receive-log/" element={<RtuReceiveLogPage />} />
          <Route path="/rtu-send-log/" element={<RtuSendLogPage />} />
          <Route
            path="/rems-interlock-add/*"
            element={
              <AuthorityCheckRoute authority={MenuAuthorityChoice.REMS}>
                <RemsInterlockAddRoutes />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/rems-send-log/"
            element={
              <AuthorityCheckRoute authority={MenuAuthorityChoice.REMS}>
                <RemsSendLogPage />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/exapi/*"
            element={
              <AuthorityCheckRoute authority={MenuAuthorityChoice.API}>
                <ExternalApiRoutes />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/exapi-send-log/"
            element={
              <AuthorityCheckRoute authority={MenuAuthorityChoice.API}>
                <ExternalApiSendLogPage />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/system/solaron-policy/"
            element={
              <AuthorityCheckRoute authority={[MenuAuthorityChoice.ADMIN]}>
                <SolaronPolicyPage />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/system/polling-inverter-models/"
            element={<AuthorityCheckRoute authority={[MenuAuthorityChoice.ADMIN]}><PollingInverterModelsPage /></AuthorityCheckRoute>}
          />
          <Route
            path="/system/device-models/"
            element={
              <AuthorityCheckRoute authority={[MenuAuthorityChoice.ADMIN]}>
                <DeviceModelSettingsPage />
              </AuthorityCheckRoute>
            }
          />
          <Route
            path="/users/"
            element={
              <AuthorityCheckRoute authority={[MenuAuthorityChoice.ADMIN]}>
                <UsersPage />
              </AuthorityCheckRoute>
            }
          />
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </AppLayout>
    </ProSidebarProvider>
  );
}
